import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {task_scheduling_template} from "../components/templates/task_scheduling_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;

export class task_scheduling extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: task_scheduling_template;
    protected timer: number;

    protected onAutocompleteInputClick(idElement): void {}
    protected onAutocompleteAddNewSelected(idElement): void {}
    protected onAutocompleteAddNewInputChange(idElement?): void {}
    protected onAutocompleteAddNewInputClick(idElement): void {}
    protected onAutocompleteAcceptSuggestion(idElement): void {}

    protected getModuleName(): string {

        return "task_scheduling";
    }

    buildContent(): Array<Element> {

        this.elementsList = new task_scheduling_template("taskScheduling", this.viewModel, this);
        this.template = this.elementsList;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Task Scheduling");

        return [this.elementsList.build()];
    }

    public fillPage(): void {

        this.getReferences();
    }

    public paginationOnPageClick(): void {

        this.getList();
    }

    public getSuggestions(keyword, idElement): void {
        const urlByElement = {
            operationFilterAutocomplete: "/api/task-scheduling/operation/search/",
            operationFormAutocomplete: "/api/task-scheduling/operation/search/",
            taskExecuterFilterAutocomplete: "/api/task-scheduling/task-executer/search/",
            taskExecuterFormAutocomplete: "/api/task-scheduling/task-executer/search/"
        };

        const searchContextByElement = {
            operationFilterAutocomplete: "filter",
            operationFormAutocomplete: "form",
            taskExecuterFilterAutocomplete: "filter",
            taskExecuterFormAutocomplete: "form"
        };
        
        const usrReq_url = urlByElement[idElement];
        const search = (keyword || "").trim();
        const searchContext = searchContextByElement[idElement];
    
        if (!usrReq_url) {
            return;
        }
    
        if (this.XHRHdls[idElement]) {
            this.XHRHdls[idElement].cancelAndReset();
        }

        if (!search) {
            this.elementsList[idElement].setOptions([]);
            this.elementsList[idElement].getTemplateViewModel().isShowOptionSuggestions(false);
    
            return;
        }
    
        const usrReq_params: Array<Array<string>> = [
            ["keyword", search],
            ["context", searchContext]
        ];
    
        const xhr = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    
        xhr.onReadyStateFunction = function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    const responseParsed = JSON.parse(req.request.response || "[]");
                
                    const options = idElement === "operationFilterAutocomplete" || idElement === "operationFormAutocomplete"
                        ? responseParsed.map((option) => ({
                            ...option,
                            displayNameComplement: option.name.replace(/([_./\\-])/g, "$1\u200B")
                        }))
                        : responseParsed;
                
                    obj.elementsList[idElement].setOptions(options);
                
                    window.setTimeout(function () {
                        obj.elementsList[idElement]
                            .getTemplateViewModel()
                            .isShowOptionSuggestions(options.length > 0);
                    }, 0);
                });
            };
        };
    
        xhr.execute();
        this.XHRHdls[idElement] = xhr;
    }

    public getOperationById(idOperation): void {
        if (this.XHRHdls["getOperationById"]) {
            this.XHRHdls["getOperationById"].cancelAndReset();
        }

        const xhr = new XMLHttpRequestHandler("/api/task-scheduling/operation/get/" + idOperation + "/", [], this);
        xhr.onReadyStateFunction = this.onGetOperationByIdReturn;
        xhr.execute();
        this.XHRHdls["getOperationById"] = xhr;
    }

    protected onGetOperationByIdReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || "{}");
                const operation = responseParsed.operation;

                if (operation) {
                    obj.setAutocompleteInputText("operationFilterAutocomplete", operation.label || operation.name || "");
                }
            });
        };
    }

    public getTaskExecuterById(idTaskExecuter): void {
        if (this.XHRHdls["getTaskExecuterById"]) {
            this.XHRHdls["getTaskExecuterById"].cancelAndReset();
        }

        const xhr = new XMLHttpRequestHandler("/api/task-scheduling/task-executer/get/" + idTaskExecuter + "/", [], this);
        xhr.onReadyStateFunction = this.onGetTaskExecuterByIdReturn;
        xhr.execute();
        this.XHRHdls["getTaskExecuterById"] = xhr;
    }

    protected onGetTaskExecuterByIdReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || "{}");
                const taskExecuter = responseParsed.taskExecuter;

                if (taskExecuter) {
                    obj.setAutocompleteInputText("taskExecuterFilterAutocomplete", taskExecuter.label || taskExecuter.name || "");
                }
            });
        };
    }

    protected onAutocompleteOptionChange(idElement): void {
        const vm = this.elementsList.getTemplateViewModel();
        const selected = this.elementsList[idElement].getOptionObj();
    
        if (idElement === "operationFilterAutocomplete") {
            vm.operationFilter(selected ? selected.id : null);
            this.setAutocompleteInputText(idElement, selected ? selected.name : "");
            this.filterDropdownOnChange();
        } else if (idElement === "operationFormAutocomplete") {
            vm.form.idOperation(selected ? selected.id : null);
            this.setAutocompleteInputText(idElement, selected ? selected.name : "");
        } else if (idElement === "taskExecuterFilterAutocomplete") {
            vm.taskExecuterFilter(selected ? selected.id : null);
            this.setAutocompleteInputText(idElement, selected ? selected.label : "");
            this.filterDropdownOnChange();
        } else if (idElement === "taskExecuterFormAutocomplete") {
            vm.form.idTaskExecuter(selected ? selected.id : null);
            this.setAutocompleteInputText(idElement, selected ? selected.label : "");
        }
    }
    
    protected onAutocompleteInputClear(idElement): void {
        const vm = this.elementsList.getTemplateViewModel();

        if (
            idElement === "operationFormAutocomplete" ||
            idElement === "taskExecuterFormAutocomplete"
        ) {
            this.elementsList[idElement].getTemplateViewModel().isShowOptionSuggestions(false);
        }
    
        if (idElement === "operationFilterAutocomplete") {
            vm.operationFilter(null);
            this.filterDropdownOnChange();
        } else if (idElement === "operationFormAutocomplete") {
            vm.form.idOperation(null);
        } else if (idElement === "taskExecuterFilterAutocomplete") {
            vm.taskExecuterFilter(null);
            this.clearAutocompleteInputNoCallback("taskExecuterFilterAutocomplete");
            this.filterDropdownOnChange();
        } else if (idElement === "taskExecuterFormAutocomplete") {
            vm.form.idTaskExecuter(null);
            this.clearAutocompleteInputNoCallback("taskExecuterFormAutocomplete");
        }
    }

    protected setAutocompleteInputText(idElement: string, text: string): void {
        const autocomplete = this.elementsList[idElement];
        autocomplete.getTemplateViewModel().inputText(text);

        const button = document.getElementById("autocomplete-input-close-" + idElement);
        if (button) {
            button.classList.toggle("is-showing", text !== "");
        }
    }

    protected clearAutocompleteInputNoCallback(idElement: string): void {
        this.elementsList[idElement].clearInputNoCallback();
    }
    

    public filterDropdownOnChange(idElement?: string): void {
        if (idElement === "scheduleTypeDropdown") {
            this.elementsList.refreshExecuteScheduleDropdownOptions();
        }
    
        this.elementsList.resetPageNumber();
        this.getList();
    }

    public reorderList(): void {

        this.getList();
    }

    protected getReferences(): void {

        let usrReq_url: string = "/api/task-scheduling/references/";
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, [], this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesReturn;
        this.XHRHdl.execute();
    }

    protected onReferencesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                obj.elementsList.setExecuteSchedules(responseParsed.executeSchedules);
                obj.elementsList.setBrandFilterItems(responseParsed.brands);
                obj.elementsList.setTaskExecuterGroupFilterItems(responseParsed.taskExecuterGroups);
                obj.elementsList.setPermissions(responseParsed.permissions);
                obj.updateViewModelFromPath();
                obj.getList();
            });
        };
    }

    protected getList(): void {

        let usrReq_url: string = "/api/task-scheduling/get/";
        this.timer = new Date().getTime();

        this.sendFilterCall(
            usrReq_url,
            this.elementsList.getViewModelForRequest(),
            this.onListReturn,
            XMLHttpRequestHandler_requestType.GET,
            "task_scheduling",
            this.elementsList.builtTemplate.children.namedItem("list-results")
        );
    }

    protected onListReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.elementsList.setItems(responseParsed.data);

                let execTime = Math.round((new Date().getTime() - obj.timer) / 1000 * 100) / 100;
                obj.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage, execTime);
                obj.elementsList.setPagination(responseParsed.totalCount);
            });

            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        };
    }

    public saveTaskScheduling(data): void {

        let usrReq_url: string = "/api/task-scheduling/save/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(data)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onSaveReturn;
        this.XHRHdl.execute();
    }

    public filterSingleGroupSelectorOnChange(idElement?: string): void {
        this.elementsList.resetPageNumber();
        this.getList();
    }

    protected onSaveReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
    
            if (req.request.status === 200) {
                obj.manageResponse(req, obj, function () {
                    obj.elementsList.hidePopup();
                    obj.getVnAppZone().notification = new vn_app_zone_notification(
                        vn_app_zone_notification.TYPE_SUCCESS,
                        "Task schedule saved successfully!"
                    );
                    obj.getVnAppZone().showNotificationToModule();
                    obj.getReferences();
                });
                return;
            }
    
            if (req.request.status === 400) {
                let responseParsed = JSON.parse(req.request.response || "{}");
    
                obj.elementsList.setValidationMessages(
                    responseParsed.validations || [{
                        field: "executeScheduled",
                        label: "Execute Scheduled",
                        messages: [responseParsed.message || "Unable to save schedule."]
                    }]
                );
                return;
            }
    
            obj.manageResponse(req, obj, function () {});
        };
    }

    public deleteTaskScheduling(id: number): void {

        if (!confirm("Delete this task schedule?")) {
            return;
        }

        let usrReq_url: string = "/api/task-scheduling/delete/" + id + "/";
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, [], this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onDeleteReturn;
        this.XHRHdl.execute();
    }

    protected onDeleteReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    "Task schedule deleted successfully!"
                );
                obj.getVnAppZone().showNotificationToModule();
                obj.getReferences();
            });
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/task_scheduling.ts